import React from 'react';
import { LogoImg } from './elements';
import { PageWrapper, Container } from '@Main/elements';
import { P } from '@helpers';
import bg from '@static/about/sfx-bg_3.png';

export const UserCentricity = ({t}) => {
    return (
      <PageWrapper darkMode={true} bgImage={bg} height="450px">
        <Container paddingTop='35px' marginLeft='102px' marginRight='35px'>
          <LogoImg/>
          <P weight='400' size='25px' height='30px' marginTop='30px'>{t("User centricity from the start")}</P>
          <P weight='400' size='15px' height='30px' marginTop='40px' width="700px">
            {t("In 2005, we were a small IT company with the sole focus of supporting exchanges and brokerages, because we were brokers.  By providing first-class technology to traders we ensure that brokerage businesses provide the best user experience during a trading journey. We know that our customers expect reliable and secure software whether it is a cryptocurrency or Forex trading domain.")} 
          </P>
        </Container>
     </PageWrapper>
  );
};
